/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity } from '@gh/core-data';
import { InspectionItemDto, SiteDetailsDto, SiteListDto } from './site.dto';

export const SiteDetailsMapper = entity<SiteDetailsDto>({
  inspectedDate: date(DateFormat.Date),
});

export const SiteListItemMapper = entity<SiteDetailsDto>({
  inspectedDate: date(DateFormat.Date),
});

export const SiteListMapper = entity<SiteListDto>({
  sites: arrayOf(SiteListItemMapper),
});

export const InspectionItemMapper = entity<InspectionItemDto>({});
